import { FilterLocation, Partner } from "@/data/partner_offering";
import { useAnalytics } from "@/lib/analytics/analytics";
import { useState, useRef } from "react";
import { LocationFilterCity } from "../components/location_picker_dropdown";

export function useLocationPicker(
  partner: Partner,
  locations: FilterLocation[]
) {
  const analytics = useAnalytics();

  const [showWhereDropdown, setShowWhereDropdown] = useState(false);
  const searchInputRef = useRef<HTMLInputElement>(null);

  const groupedCities: LocationFilterCity[] = [];
  for (const location of locations) {
    const city = groupedCities.find((c) => c.label === location.city);
    if (city) {
      city.numberOfRooms++;
      const cityLocation = city.locations.find((l) => l.id === location.id);
      if (cityLocation) {
        cityLocation.numberOfRooms++;
      } else {
        city.locations.push({
          id: location.id,
          label: location.locationDisplay,
          numberOfRooms: 1,
        });
      }
    } else {
      groupedCities.push({
        label: location.city,
        numberOfRooms: 1,
        locations: [
          {
            id: location.id,
            label: location.locationDisplay,
            numberOfRooms: 1,
          },
        ],
      });
    }
  }

  const handleToggle = (show: boolean) => {
    setShowWhereDropdown(show);
    if (show) {
      setTimeout(() => searchInputRef.current?.focus());
      analytics.event(
        "Location Dropdown click",
        {
          "Partner UUID": partner.id,
          "Partner Name": partner.name,
          "Partner Internal Name": partner.internalName,
          Source: "WL",
        },
        { onlyProviders: ["mixpanel", "customerio"] }
      );
    }
  };

  return {
    showWhereDropdown,
    searchInputRef,
    groupedCities,
    handleToggle,
  };
}
